<template>
  <div class="">
    <select v-model="selectedValue" @change="emitData" class="form-control">
      <option value="null">همه</option>
      <option value="0">کاربر عادی</option>
      <option value="1">مدیر سایت</option>
      <option value="2">فروشگاه</option>
      <option value="3">ویرایشگر</option>
      <option value="4">نویسنده</option>
      <option value="5">مدیریت سفارشات</option>
    </select>
  </div>
</template>

<script>
export default {
  name: "UserRole1",
  data() {
    return {
      selectedValue: null
    }
  },
  methods: {
    emitData() {
      this.$emit('updateFilter', [this.selectedValue])
    }
  }
}
</script>
<style scoped>

</style>